import * as Common from '@/tenant/common';

export class ReceivePaymentResultReportQuery extends Common.Query {
    constructor(){
        super("ReceivePaymentResultReportQuery", null);
    }
    public templateId:number=0;
    public segment: Common.Segment = null;
    public counterpart: Common.Counterpart = null;
    public bankAccount: Common.BankAccount = null;
    public startDate: Date = null;
    public endDate: Date = null;
    public onExcelExport:boolean = false;           
}

export class ReceivePaymentResultReportTemplateQuery extends Common.ReportTemplateQuery {
  queryName ='ReceivePaymentResultReportQuery';
  sort = 'id';
  constructor() {
    super();
  }
}